"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        sectionHeaderText: function (_a) {
            var open = _a.open;
            return ({
                color: open ? theme.custom.slideout.mutedText : theme.custom.slideout.contrastText,
                textTransform: 'uppercase',
                paddingRight: "".concat(theme.spacing(1), "px"),
                paddingLeft: "".concat(theme.spacing(1), "px"),
                position: 'inherit'
            });
        },
        sectionHeaderContent: {
            '&.MuiListItem-gutters': {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
            },
        },
        collapseList: {
            margin: "".concat(theme.spacing(0.25), "px ").concat(theme.spacing(1), "px ").concat(theme.spacing(1), "px ").concat(theme.spacing(1), "px"),
        },
        collapseOptions: {
            padding: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(1), "px"),
            borderRadius: theme.spacing(0.5),
            '&.MuiListItem-gutters:hover': {
                backgroundColor: 'rgba(136,136,136, 0.8)',
            },
            '&.Mui-selected': {
                color: theme.palette.secondary.main,
                backgroundColor: 'transparent',
                fontWeight: 500,
            },
            '&.Mui-selected .MuiListItemText-root span': {
                fontWeight: 700,
            },
        },
    });
});
